var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSocialIconInstagramd3Eecf33C9514159F36A0928B6A3Ca3F(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Group 28732",
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.536,
    height: 29.536,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 47",
    d: "M18.734 9.26h.155a1.352 1.352 0 011.352 1.352v.08a1.353 1.353 0 01-1.352 1.353h-.155a1.352 1.352 0 01-1.352-1.351v-.082a1.352 1.352 0 011.352-1.352z",
    fill: "#d50060"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 66",
    d: "M14.781 17.477a2.741 2.741 0 10-2.827-2.74 2.785 2.785 0 002.827 2.74z",
    fill: "#d50060"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 67",
    d: "M19.157 14.911a4.377 4.377 0 01-8.75 0 4.091 4.091 0 01.18-1.208H9.29v5.945a.561.561 0 00.559.559h9.8a.561.561 0 00.56-.559v-5.945H18.97a4.139 4.139 0 01.187 1.208z",
    fill: "#d50060"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 68",
    d: "M14.768 0a14.768 14.768 0 1014.768 14.768A14.768 14.768 0 0014.768 0zm7.089 20.037a1.824 1.824 0 01-1.819 1.82H9.499a1.825 1.825 0 01-1.82-1.82V9.498a1.825 1.825 0 011.82-1.819h10.538a1.824 1.824 0 011.819 1.819z",
    fill: "#d50060"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialIconInstagramd3Eecf33C9514159F36A0928B6A3Ca3F);
export default __webpack_public_path__ + "static/media/social-icon-instagram.d3eecf33c9514159f36a0928b6a3ca3f.cd635d4aec421f2cdb78f3a98038f031.svg";
export { ForwardRef as ReactComponent };